import { request } from 'Features/auth/axios-client'
import { useMutation, useQuery } from 'react-query'
import {
  UpdateAlternativeWorkcentreDataMutationParams,
  UpdateAlternativeWorkcentreDataParams,
  AlternativeWorkcentrePageURLTypes,
} from './AlternativeWorkcenters.types'
import { WORKCENTRE_STATUS_FETCH_TIMEOUT } from 'Common/Constants/Constants'

const fetchAlternativeWorkcentreData = async (
  planId: string,
  workcentreId: string,
  sourcesiteId: string
) => {
  const data = await request({
    url: `/plan/${planId}/source-site/${sourcesiteId}/primary-workcentre/${workcentreId}/alternative-workcentres`,
    method: 'GET',
  })
  return data
}

export const useAlternativeWorkcentreData = (
  planId: string,
  workcentreId: string,
  sourcesiteId: string
) => {
  return useQuery(
    ['alternativeWorkcentreData', planId, workcentreId, sourcesiteId],
    () => fetchAlternativeWorkcentreData(planId, workcentreId, sourcesiteId),
    {
      enabled: true,
      select: ({ data }) => {
        return data?.data
      },
      refetchOnWindowFocus: false,
    }
  )
}

const UpdateAlternativeWorkcentreData = async ({
  data,
  planId,
  workcentreId,
  sourcesiteId,
}: UpdateAlternativeWorkcentreDataParams) => {
  const response = await request({
    url: `/plan/${planId}/source-site/${sourcesiteId}/primary-workcentre/${workcentreId}/alternative-workcentres`,
    method: 'PUT',
    data: data,
  })
  return response
}

export const useUpdateAlternativeWorkcentreData = ({
  onSuccess,
  onError,
}: UpdateAlternativeWorkcentreDataMutationParams) => {
  return useMutation(UpdateAlternativeWorkcentreData, {
    onSuccess: () => {
      onSuccess()
    },
    onError: (error) => {
      onError(error)
    },
  })
}

const fetchWorkcentreRunStatus = async (
  params: AlternativeWorkcentrePageURLTypes
) => {
  const { planId, sourcesiteId, workcentreId } = params
  const data = await request({
    url: `plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/run-status`,
  })
  return data
}

export const useWorkcentreRunStatus = (
  params: AlternativeWorkcentrePageURLTypes
) => {
  return useQuery(
    [
      'workcentre-run-status',
      params.planId,
      params.sourcesiteId,
      params.workcentreId,
    ],
    () => fetchWorkcentreRunStatus(params),
    {
      cacheTime: 0,
      select: (response) => response?.data?.data,
      refetchOnWindowFocus: true,
      refetchInterval: WORKCENTRE_STATUS_FETCH_TIMEOUT,
    }
  )
}
